import { modalAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { defineMultiStyleConfig } = createMultiStyleConfigHelpers(modalAnatomy.keys);

export const Modal = defineMultiStyleConfig({
	baseStyle: {
		overlay: {
			bg: 'bg.overlayBackdrop',
		},
		content: {
			bgColor: 'bg.soft',
		},
		closeButton: {
			borderRadius: 'full',
			bgColor: 'secondary.bgAlpha',
			top: 3,
			_hover: {
				bgColor: 'secondary.bgAlphaHover',
			},
		},

		header: {
			borderBottomWidth: '1px',
			borderBottomStyle: 'solid',
			borderBottomColor: 'border.default',
		},
	},
});
